import React, { Component } from 'react'
import {
	Spin,
	Divider,
	Alert,
} from 'antd'
// import debounce from 'lodash/debounce'
// import MeasureUnitForm from './MeasureUnitForm';
import API from '../../../services/API'
// import { objectToFormData } from '../../../services/Utils'
import InventoryTransferForm from './InventoryTransferForm';

// eslint-disable-next-line no-unused-vars
// const Option = Select.Option;

const INITIAL_DATA = {
	name: '',
	description: '',
    active: 0,
    created_at: '',
    updated_at: '',
}

class InventoryTransferContainer extends Component {
	constructor(props) {
        super()
        const { id } = props.match.params;
        this.id = id;
    }

    id = null;

	state = {
		data: INITIAL_DATA,
		loading: false,
        response: null,
        editFormData: {},

        isLoaded: false,
	}

	componentDidMount() {
		// this.getAdditionalData()
		this.setState({
			isLoaded: true,
		});
	}

	getAdditionalData = () => {

	}

	save = async (data) => {
		await this.setState({
			loading: true,
			response: null,
		})

		const state = {
			...this.state,
			loading: false,
		}

		try {
			// eslint-disable-next-line no-unused-vars
			const response = await API.post('/api/inventory/transfer', data)
			state.response = {
				type: 'success',
				message: 'Los cambios se hicieron con exito!',
			}
			this.setState({
				// eslint-disable-next-line comma-dangle
				...state
			})
			setTimeout(() => {
				window.location.reload(true);
			}, 400);
		} catch (error) {
			state.response = {
				type: 'error',
				message: error.response
					? error.response.data.message
					: 'Se produjo un error de conexión',
			}
		}

		this.setState({
			// eslint-disable-next-line comma-dangle
			...state
		})
	}

	getValuesForm = (values) => {
		this.save(values)
	}

	render() {
		return (
			<React.Fragment>
				<div
					style={{
						backgroundColor: 'white',
						borderRadius: 3,
						padding: '8px 16px 16px',
					}}
				>
					<Spin
						spinning={this.state.loading}
						tip="Espere, por favor..."
					>
						<React.Fragment>
							{this.state.response && (
								<Alert
									message={
										this.state.response.type === 'success'
											? 'Éxito'
											: 'Error'
									}
									description={this.state.response.message}
									type={this.state.response.type}
									showIcon
									closable
									onClose={() => this.setState({ response: null })}
								/>
							)}
							<Divider>Tranferencia de inventario</Divider>

							{
								this.state.isLoaded ? (
									<InventoryTransferForm
										getValues={this.save}
									/>
								) : (null)
							}

						</React.Fragment>
					</Spin>
				</div>
			</React.Fragment>
		)
	}
}

export default InventoryTransferContainer
